import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ServerDocTypeHdrResponseDtoModel } from "../../../data-transfer-objects/server-doc-type-hdr-dto.model";
import { BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({
  providedIn: "root",
})
export class ServerDocTypeHeaderService extends BaseApiTemplateService<ServerDocTypeHdrResponseDtoModel[]> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +  "generic-doc/server-doc-types/headers";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "generic-doc/server-doc-types/headers";
    this.httpClient = http;
  }

}